// Test IDs for the GM account password-reset tool.

export const ACCOUNTS_ADMIN = {
  page: 'accounts-admin-page',
  guard: 'accounts-admin-guard',
  searchInput: 'accounts-admin-search-input',
  resultRow: 'accounts-admin-result-row',
  resetButton: 'accounts-admin-reset-button',
  dialog: 'accounts-admin-password-dialog',
  passwordInput: 'accounts-admin-password-input',
  submitButton: 'accounts-admin-submit-button',
};
